// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { accountHasValidOrigin } from '../../actions/index';
import { connect } from 'react-redux';

class LinkedButton extends PureComponent {
  static propTypes = {
    href: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]).isRequired,
  };

  render() {
    const { href, children, dispatch, ...rest } = this.props;

    return (
      <Link to={href} className="no-underline">
        <span {...rest} onClick={() => dispatch(accountHasValidOrigin())}>
          {children}
        </span>
      </Link>
    );
  }
}

export default connect()(LinkedButton);